import type {
  AiNotification,
  AiNotificationStore,
} from "@/types/stores/ai-notification";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  currentNotification: null,
};

export const useAiNotificationStore = create<AiNotificationStore>()(
  devtools(
    (set) => ({
      ...initialState,

      showNotification: (message, isError = false) => {
        const notification: AiNotification = {
          message,
          type: isError ? "error" : "info",
          timestamp: Date.now(),
        };

        set(
          { currentNotification: notification },
          false,
          "ai-notification/show"
        );

        // Auto-clear after 5 seconds
        setTimeout(() => {
          set(
            (state) => {
              // Only clear if this is still the current notification
              if (
                state.currentNotification?.timestamp === notification.timestamp
              ) {
                return { currentNotification: null };
              }
              return state;
            },
            false,
            "ai-notification/auto-clear"
          );
        }, 5000);
      },

      clearNotification: () =>
        set({ currentNotification: null }, false, "ai-notification/clear"),
    }),
    {
      name: "ai-notification-store",
    }
  )
);

// Selector hooks
export const useAiNotification = () =>
  useAiNotificationStore((state) => state.currentNotification);

export const useShowAiNotification = () =>
  useAiNotificationStore((state) => state.showNotification);

export const useClearAiNotification = () =>
  useAiNotificationStore((state) => state.clearNotification);

